(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventView",
                    {
                        url: "/EventGroup/:EventGroupId/Event/:EventId",
                        component: "eventView",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Events.EventView.Details"
                    });
        }
    ]);

    app
        .component("eventView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventView/event-view-template.html",
                controller: eventViewController
            });

    eventViewController.$inject = ["$state", "$mdDialog", "$stateParams", "marketingTrackerEventGroupApi", "figToaster", "featureToggleService"];
    function eventViewController($state, $mdDialog, $stateParams, marketingTrackerEventGroupApi, figToaster, featureToggleService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    deleting: false
                },
                deleteEvent: deleteEvent
            });

        function deleteEvent($event) {

            var message = "", toastClass = "";

            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this event? This action is permanent.",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Delete Event",
                cancel: "Cancel",
                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                return marketingTrackerEventGroupApi.deleteEvent($ctrl.eventGroupId, $ctrl.eventId)
                    .then(function () {
                        $ctrl.ui.deleting = false;
                        $state.go("Home.Tools.MarketingTrackerNew.Event.Calendar");
                        message = "Event deleted.";
                        toastClass = "is-success";
                        $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroupId,
                            eventId: $ctrl.eventId,
                            toDelete: true
                        });
                        return figToaster.showSimple(message, "top", toastClass);
                    })
                    .catch(function (error) {
                        message = "Error: " + error.data;
                        toastClass = "is-error";
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            });
        }

        $ctrl.$onInit = function () {
            $ctrl.eventGroupId = $stateParams.EventGroupId;
            $ctrl.eventId = $stateParams.EventId;
            $ctrl.toggleFeature = featureToggleService.checkEnv();
        };
    }

})(window.app, window.angular); //jshint ignore:line